import React from 'react';

import { Content } from './Content';

/**
 * @typedef {Object} DetailsOverviewProps
 * @property {object} detailsOverviewFetchState
 */

/**
 * @param {DetailsOverviewProps} props
 */
export const DetailsOverview = ({ detailsOverviewFetchState }) => {
  return <Content detailsOverview={detailsOverviewFetchState} />;
};
